import AllToggle from '@components/Toggles/AllToggle';
import CameraToggle from '@components/Toggles/CameraToggle';
import ContentShareToggle from '@components/Toggles/ContentShareToggle';
import ExitToggle from '@components/Toggles/ExitToggle';
import MicToggle from '@components/Toggles/MicToggle';
import RestartToggle from '@components/Toggles/RestartToggle';
import SpeakerToggle from '@components/Toggles/SpeakerToggle';
import { Container } from './style';

const FeatureController = () => {
  return (
    <Container>
      <ContentShareToggle />
      <MicToggle />
      <CameraToggle />
      <SpeakerToggle />
      <AllToggle />
      <RestartToggle />
      <ExitToggle />
    </Container>
  );
};

export default FeatureController;
